const DESCRIPTION_MAX_LENGTH = 200;
const BRAND_SUFFIX = ' | 7Cantos';
const DWELLING_TYPES = new Set([
  'apartamento',
  'casa',
  'kitnet',
  'kitinete',
  'studio',
  'estudio',
  'estúdio',
  'sobrado',
  'cobertura',
  'loft',
  'flat',
]);

function buildPropertySearchTitle(property) {
  const type = inferDwellingType(property);
  const rooms = roomLabel(property && property.rooms);
  const place = placeLabel(property);
  const headline = type
    ? [type, rooms].filter(Boolean).join(' ')
    : (rooms ? `Imóvel de ${rooms}` : '');

  if (!headline && !place) {
    const fallback = String((property && property.title) || '').trim();
    return fallback ? `${fallback}${BRAND_SUFFIX}` : `Imóvel para alugar${BRAND_SUFFIX}`;
  }

  const lead = headline || 'Imóvel';
  return `${lead} para alugar${place ? ` no ${place}` : ''}${BRAND_SUFFIX}`;
}

function buildPropertySearchDescription(property, maxLength) {
  const limit = maxLength || DESCRIPTION_MAX_LENGTH;
  const listingText = String((property && property.description) || '').trim();
  if (listingText) {
    return truncate(listingText, limit);
  }

  const rooms = roomLabel(property && property.rooms);
  const place = placeLabel(property);
  const price = formatRent(property && property.rent_value);
  const parts = ['Imóvel para alugar'];
  if (place) parts.push(`em ${place}`);
  if (rooms) parts.push(`com ${rooms}`);
  if (price) parts.push(`por ${price}`);
  return truncate(`${parts.join(' ')}.`, limit);
}

function replacePrimarySeoTags(doc, seo) {
  doc.title = seo.title;
  setMeta(doc, 'name', 'description', seo.description || '');
  setMeta(doc, 'property', 'og:title', seo.title);
  setMeta(doc, 'property', 'og:description', seo.description || '');
  setMeta(doc, 'property', 'og:url', seo.canonicalUrl);
  setMeta(doc, 'name', 'twitter:title', seo.title);
  setMeta(doc, 'name', 'twitter:description', seo.description || '');
  setLink(doc, 'canonical', seo.canonicalUrl);
  if (seo.imageUrl) {
    setMeta(doc, 'property', 'og:image', seo.imageUrl);
    setMeta(doc, 'name', 'twitter:image', seo.imageUrl);
    setMeta(doc, 'property', 'og:image:alt', seo.imageAlt || seo.title);
    setMeta(doc, 'name', 'twitter:image:alt', seo.imageAlt || seo.title);
  }
}

function inferDwellingType(property) {
  const title = String((property && property.title) || '');
  const firstSegment = title.split(',')[0].trim().toLowerCase();
  if (!DWELLING_TYPES.has(firstSegment)) {
    return '';
  }
  return firstSegment.charAt(0).toUpperCase() + firstSegment.slice(1);
}

function roomLabel(rooms) {
  const count = Number(rooms);
  if (!Number.isFinite(count) || count <= 0) {
    return '';
  }
  return count === 1 ? '1 quarto' : `${count} quartos`;
}

function placeLabel(property) {
  const address = property && property.address;
  if (!address) {
    return '';
  }
  return [address.neighborhood, address.city].filter(Boolean).join(', ');
}

function formatRent(value) {
  const amount = Number(String(value == null ? '' : value).replace(',', '.'));
  if (!Number.isFinite(amount) || amount <= 0) {
    return '';
  }
  const [whole, fraction] = amount.toFixed(2).split('.');
  const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return `R$ ${grouped},${fraction}`;
}

function truncate(value, maxLength) {
  if (value.length <= maxLength) {
    return value;
  }
  return `${value.slice(0, maxLength - 3).trim()}...`;
}

function setMeta(doc, attribute, attributeValue, content) {
  const nodes = Array.from(doc.querySelectorAll(`meta[${attribute}="${attributeValue}"]`));
  if (nodes.length === 0) {
    const meta = doc.createElement('meta');
    meta.setAttribute(attribute, attributeValue);
    meta.setAttribute('content', content);
    doc.head.appendChild(meta);
    return;
  }
  nodes[0].setAttribute('content', content);
  nodes.slice(1).forEach((node) => {
    if (node.parentNode) {
      node.parentNode.removeChild(node);
    }
  });
}

function setLink(doc, rel, href) {
  const nodes = Array.from(doc.querySelectorAll(`link[rel="${rel}"]`));
  if (nodes.length === 0) {
    const link = doc.createElement('link');
    link.setAttribute('rel', rel);
    link.setAttribute('href', href);
    doc.head.appendChild(link);
    return;
  }
  nodes[0].setAttribute('href', href);
  nodes.slice(1).forEach((node) => {
    if (node.parentNode) {
      node.parentNode.removeChild(node);
    }
  });
}

module.exports = {
  DESCRIPTION_MAX_LENGTH,
  buildPropertySearchTitle,
  buildPropertySearchDescription,
  replacePrimarySeoTags,
};
